import React, { useState } from "react";
import { Button, useMediaQuery, useTheme } from "@mui/material";
import SupportAgentIcon from "@mui/icons-material/SupportAgent";

import CrispTicketFormModal from "./CrispTicketFormModal";
import CrispTicketPanel from "./CrispTicketPanel";

const CrispSupportFloatingButtons = () => {
  const [isFormOpen, setIsFormOpen] = useState(false);
  const [isTicketListOpen, setIsTicketListOpen] = useState(false);
  const [selectedTicketId, setSelectedTicketId] = useState(null);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));

  const openTicketPanel = (ticketId) => {
    setIsFormOpen(false);
    setSelectedTicketId(ticketId || null);
    setIsTicketListOpen(true);
  };

  const closeTicketPanel = () => {
    setIsTicketListOpen(false);
    setSelectedTicketId(null);
  };

  return (
    <>
      <Button
        variant="contained"
        color="secondary"
        onClick={() => setIsFormOpen(true)}
        startIcon={<SupportAgentIcon />}
        sx={{
          position: "fixed",
          bottom: 88,
          right: 20,
          zIndex: 1300,
          borderRadius: 999,
          px: 2,
          boxShadow: 3,
          textTransform: "none",
          fontWeight: 600,
        }}
      >
        Tickets
      </Button>

      <CrispTicketFormModal
        open={isFormOpen}
        onClose={() => setIsFormOpen(false)}
        onViewTickets={openTicketPanel}
        onTicketCreated={openTicketPanel}
      />

      <CrispTicketPanel
        open={isTicketListOpen}
        ticketId={selectedTicketId}
        onClose={closeTicketPanel}
        fullScreen={isSmallScreen}
      />
    </>
  );
};

export default CrispSupportFloatingButtons;
